import { ProductOld } from 'src/admin-entity/interface/product/product-old.interface';
import { CategorySaleStatistics } from 'src/admin-entity/interface/statistics/category-sale-statistics.interface';
import { DateSaleStatistics } from 'src/admin-entity/interface/statistics/date-sale-statistics.interface';
import { DistributorSaleStatistics } from 'src/admin-entity/interface/statistics/distributor-sale-statistics.interface';
import { GradeSaleStatistics } from 'src/admin-entity/interface/statistics/grade-sale-statistics.interface';
import { PaymentMethodTypeSaleStatistics } from 'src/admin-entity/interface/statistics/payment-method-type-sale-statistics.interface';
import { ProductSaleStatistics } from 'src/admin-entity/interface/statistics/product-sale-statistics.interface';
import { SumStatistics } from 'src/admin-entity/interface/statistics/sum-statistics.interface';

export interface StatisticsInitType {
    saleType: string;
    dateType: string;
    beginDate: string;
    endDate: string;
    selectedProducts: ProductOld[];
    category: {
        id: number;
        name: string;
    };
    distributor: {
        id: number;
        name: string;
    };
    paymentMethodType: string;
    gradeList: string[];
    discountType: string[];
    taxStatus: string;
    page: number;
    take: number;

    searchType: string;
    searchResult: {
        page: {
            count: number;
        };
        list:
            | CategorySaleStatistics[]
            | ProductSaleStatistics[]
            | DateSaleStatistics[]
            | DistributorSaleStatistics[]
            | GradeSaleStatistics[]
            | PaymentMethodTypeSaleStatistics[];
    };
    sumStatistics: SumStatistics;
}

export const statisticsInitState: StatisticsInitType = {
    saleType: 'date',
    dateType: 'day',
    beginDate: new Date(new Date().setDate(new Date().getDate() - 6)).toString(),
    endDate: Date(),
    selectedProducts: [],
    category: {
        id: 0,
        name: '',
    },
    distributor: {
        id: 0,
        name: '',
    },
    paymentMethodType: '',
    gradeList: [],
    discountType: [],
    taxStatus: '',
    page: 0,
    take: 20,

    searchType: 'date',
    searchResult: {
        page: {
            count: 2000,
        },
        list: [],
    },
    sumStatistics: {
        cancelOipCount: 0,
        coupon: 0,
        date: '2024-07-24 2024-07-24',
        beginDate: Date(),
        endDate: Date(),
        netSale: 0,
        oipCount: 0,
        optionUnit: 0,
        rewardPoint: 0,
        sumPaidPrice: 0,
        sumPrice: 0,
        sumShippingFee: 0,
        sumSupplyPrice: 0,
        sumWithdrawPrice: 0,
        usedPoint: 0,
        lastUpdateTime: '',
    },
};
